import { render, staticRenderFns } from "./PaginationEllipsis.vue?vue&type=template&id=c56a9100&scoped=true&"
import script from "./PaginationEllipsis.vue?vue&type=script&lang=js&"
export * from "./PaginationEllipsis.vue?vue&type=script&lang=js&"
import style0 from "./PaginationEllipsis.vue?vue&type=style&index=0&id=c56a9100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56a9100",
  null
  
)

export default component.exports